import React from 'react'
import styles from './InstructionList.module.css'
import Instruction from '../../components/Instruction/Instruction'
import { useTranslation } from 'react-i18next'
const InstructionList = (props) => {
    const { i18n } = useTranslation()
    return (
        <div className={styles.instructionlist}>
            <Instruction
                data={
                    props.instructions.instruction
                        ? props.instructions.instruction.instruction[i18n.language]
                        : ''
                }
            />
        </div>
    )
}

export default InstructionList
